/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
// Internal Imports
import E_SIGN_FLOW from "../Configuration/eSignConfig";

// eslint-disable-next-line import/prefer-default-export
export const reactionsOnESignBtnClick = async ({ payload }) => {
  // Reset payload value on every parser run
  payload.break = false;
  payload.viewToShow = "";
  Object.seal(payload);

  try {
    for (const [index, func] of E_SIGN_FLOW.entries()) {
      if (
        !payload.break &&
        (!payload.lastExecutedMethodIndex ||
          payload.lastExecutedMethodIndex === index)
      ) {
        await func.method({ payload });
        payload.lastExecutedMethodIndex = payload.break ? index : null;
      }
    }
    return payload.viewToShow;
  } catch (err) {
    console.error("Parser => handleRippleEffectOnCellChange", err);
  }

  return null;
};

// ======================================================================



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Parser/index.js